import React from 'react';
import { Disc3Icon, SendIcon, Wrench as WrenchIcon } from 'lucide-react';
import { DEMO_FORM_URL } from '../../data/site';
import { Reveal } from '../Reveal';
import { SectionHeading } from '../SectionHeading';

/* CONTACT — replaced the Newsletter section (Ryan, Aug 29); compacted twice same
   day: the two lanes are now horizontal mini-rows (icon left, label + email
   right), blurbs dropped. Event Production → info@, Record Label → ryan@, plus a
   SEND A DEMO pill → the ClickUp demo form. Newsletter.tsx archived in repo. */

const CONTACTS = [{
  icon: WrenchIcon,
  eyebrow: 'EVENT PRODUCTION',
  email: 'info@futureastronautco.com',
  accent: 'cyan' as const
}, {
  icon: Disc3Icon,
  eyebrow: 'RECORD LABEL',
  email: 'ryan@futureastronautco.com',
  accent: 'violet' as const
}];
export function Contact() {
  return <section id="contact" className="relative mx-auto w-full max-w-7xl px-5 py-14 sm:px-8 sm:py-16" data-id="element-101" data-mp="2u8htjfyfwl0u">
      <SectionHeading align="center" eyebrow="GET IN TOUCH" title={<>
            Contact <span className="text-gradient" data-id="element-103" data-mp="269n3ha8eh6fa">mission control</span>
          </>} description="Booking a show, building a stage, or bringing us a record — pick your lane." data-id="element-102" data-mp="2y9l7ty0ua8zy" />

      <div className="mx-auto mt-7 grid w-full max-w-2xl gap-3 sm:grid-cols-2" data-id="element-104" data-mp="2fz6s6wisnui2">
        {CONTACTS.map((c, i) => {
        const Icon = c.icon;
        const cyan = c.accent === 'cyan';
        return <Reveal key={c.email} delay={i * 0.06} data-id="element-105" data-mp="1nb12rwgsphbw" data-mpi={i}>
              <a href={`mailto:${c.email}`} className={`glass group flex items-center gap-3.5 rounded-2xl px-4 py-3.5 transition-[transform,border-color,box-shadow] duration-300 ease-expo hover:-translate-y-0.5 ${cyan ? 'hover:border-cyan/50 hover:shadow-neon-cyan' : 'hover:border-violet/50 hover:shadow-neon'}`} data-id="element-106" data-mp="1ncc65v6bwn2h">
                <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl border ${cyan ? 'border-cyan/40 bg-cyan/10 text-cyan' : 'border-violet/40 bg-violet/10 text-violet-soft'}`} data-id="element-107" data-mp="3frant9zb5hcb">
                  <Icon className="h-4 w-4" aria-hidden="true" data-id="element-108" data-mp="3un9v4ielfdge" />
                </span>
                <span className="min-w-0" data-id="element-109" data-mp="2x12oz42n5d1x">
                  <span className={`block font-tech text-[0.58rem] font-semibold tracking-[0.22em] ${cyan ? 'text-cyan/85' : 'text-violet-soft'}`} data-id="element-110" data-mp="2x2dtj63wuou3">
                    {c.eyebrow}
                  </span>
                  <span className="mt-0.5 block truncate font-tech text-[0.78rem] font-medium text-white underline-offset-4 group-hover:underline" data-id="element-111" data-mp="3br0998xg9ilu">
                    {c.email}
                  </span>
                </span>
              </a>
            </Reveal>;
      })}
      </div>

      <Reveal delay={0.12} data-id="element-112" data-mp="10cqehf82cdqr">
        <div className="mt-6 flex flex-col items-center gap-1.5 text-center" data-id="element-113" data-mp="10bxfj0fcisj6">
          <a href={DEMO_FORM_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-2 rounded-full bg-violet px-7 py-3 font-tech text-[0.8rem] font-semibold tracking-[0.16em] text-white shadow-neon transition-[transform,background-color] duration-200 ease-expo hover:scale-[1.03] hover:bg-violet-soft" data-id="element-114" data-mp="wcy8naa20lp3">
            <SendIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-115" data-mp="cmcmfophaew6" />
            SEND A DEMO
          </a>
          <p className="font-script text-[0.95rem] text-magenta" data-id="element-116" data-mp="8krfejzmkutw">Submissions open October 2026</p>
        </div>
      </Reveal>
    </section>;
}